import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "src/Components/Button";
import useRequest from "src/Hooks/useRequest";
import { IOrderbook } from "src/Interfaces/orderbook";
import { getOrderbooks, setOrderbooks } from "src/Requests/orderbook";
import { packetErrorHandler } from "src/Utils/requestUtils";
import EditableOrderbookTable from "./EditableOrderbookTable";

const OrderBookPage = () => {
  const [values, setValues] = useState<IOrderbook[]>([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const orderbookRequest = useRequest(getOrderbooks, packetErrorHandler);

  useEffect(() => {
    orderbookRequest.fetchData();
  }, []);

  useEffect(() => {
    if (orderbookRequest.response) {
      setValues(orderbookRequest.response);
    }
  }, [orderbookRequest.response]);

  const orderbookChangeHandler = (index: number, value: IOrderbook) => {
    setValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = value;
      return newValues;
    });
  };
  const removeOrderbookHandler = (index: number) => {
    setValues((prevValues) => prevValues.filter((_, i) => i !== index));
  };

  const submitHandler = () => {
    setSubmitLoading(true);
    setOrderbooks(values)
      .then((resp) => {
        toast.success("Saved");
      })
      .catch(packetErrorHandler)
      .finally(() => setSubmitLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start p-4 mt-8">
      <div className="flex flex-row justify-start items-start gap-3 flex-wrap w-full">
        {values.map((value, index) => (
          <EditableOrderbookTable
            key={`${value.code}-${index}`}
            tableInfo={value}
            onChange={(newValue) => orderbookChangeHandler(index, newValue)}
            onRemove={() => removeOrderbookHandler(index)}
          />
        ))}
      </div>
      <div className="w-64 flex flex-row justify-start items-center gap-5 mt-3">
        <Button
          variant="contained"
          text="دریافت Orderbook"
          onClick={() => orderbookRequest.fetchData()}
          loading={submitLoading}
          disabled={submitLoading || !values.length}
        />
        <div className="w-min">
          <Button
            variant="contained"
            text="ثبت"
            onClick={submitHandler}
            loading={submitLoading}
            disabled={submitLoading || !values.length}
          />
        </div>
      </div>
    </div>
  );
};

export default OrderBookPage;
